import { render, staticRenderFns } from "./recording-position-tracker.vue?vue&type=template&id=830b76de&scoped=true&"
import script from "./recording-position-tracker.vue?vue&type=script&lang=js&"
export * from "./recording-position-tracker.vue?vue&type=script&lang=js&"
import style0 from "./recording-position-tracker.vue?vue&type=style&index=0&id=830b76de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830b76de",
  null
  
)

component.options.__file = "recording-position-tracker.vue"
export default component.exports